import api from './axios';

export const getUsersApi = (params = {}) => api.get('/admin/users', { params });
export const getUserFilterOptionsApi = () => api.get('/admin/users/filter-options');
export const getNewUsersCountApi = () => api.get('/admin/users/new-count');
export const markUsersSeenApi = () => api.post('/admin/users/mark-seen');
export const getUserProfileApi = (userId) => api.get(`/admin/users/${userId}`);
export const updateUserApi = (userId, data) => api.put(`/admin/users/${userId}`, data);
export const exportUsersApi = (params = {}) =>
  api.get('/admin/users/export', { params, responseType: 'blob' });
